/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { connect } from "react-redux";
import { currentLocationInfo } from "../../home/redux/actions";
import {  InputGroup, //FormControl,
   Form} from "react-bootstrap";
import { geocodeAddress, GetLocationList } from "../util/getRequest";
import { maintainAirportlist } from "../../header/redux/actions";
import { reverseGeocode } from "./../util/getRequest";
import { LocationMapList } from "./PlaceautocompletePage";

function PlacesAutocompletePage (props) {
  const [locationList, SetLocationList] = useState([])
  const [ShowList, SetShowList] = useState(false);
  const [cursor, setCursor] = useState(0)
  const locationValueChange =async (address) => {
    props?.setAddress(address);
    const Responce = await GetLocationList(address);
    if(Responce?.status === "OK"){
      if(!ShowList)
      SetShowList(true)
      SetLocationList(Responce?.predictions);
    }
  };

  const OnSelectLocationHandler =async (e, index) =>{
    e.preventDefault();
    const SelectList = locationList?.filter((item, index1)=>index === index1);
    if(SelectList?.length >0){
      getGeoCode(SelectList[0]?.description)
    }else{
      getGeoCode(props?.address)
    }
    SetShowList(false)
    SetLocationList([])
  }
  const getGeoCode = async (address) =>{
    const responce = await geocodeAddress(address);
    if(responce?.status === "OK" && responce?.results){
        const place  = responce?.results[0];
        const Lat = place?.geometry?.location?.lat;
        const lng = place?.geometry?.location?.lng;
        const ZipCode  = await reverseGeocode({ latitude:Lat, longitude:lng });
        props?.SetLocation({place, address:address,Lat, lng, ZipCode })
        ResetState()
    }
    // const geocoder = new window.google.maps.Geocoder();
    // geocoder.geocode({'address': address},async function(results, status) {
    //     if (status == window.google.maps.GeocoderStatus.OK) {
    //       if(results){
    //         const place = results[0];
    //         const Lat = place?.geometry?.location?.lat();
    //         const lng = place?.geometry?.location?.lng();
    //         const ZipCode  = await reverseGeocode({ latitude:Lat, longitude:lng });
    //         props?.SetLocation({place, address:address,Lat, lng, ZipCode })
    //         ResetState()
    //       }
    //     }
    // });
  }
  const handleKeyDown = (e) =>{
    if(e.key === 'Enter'){
      OnSelectLocationHandler(e, cursor)
    }else if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1)
    } else if (e.keyCode === 40 && cursor < locationList.length - 1) {
      setCursor(cursor + 1)
    }
  }
  const ResetState = () =>{
    SetShowList(false);
    setCursor(0)
    SetLocationList([]);
  }
  return (
    <React.Fragment>
      <div className={`${props?.className} position-relative Location_dropdown transition`}>
          <InputGroup onClick={()=>SetShowList(true)} htmlFor={"Location_Search2"} >
            <Form.Control
              placeholder={props?.placaddress? props?.placaddress: props.currentLocation.selectedLocation}
              value={props?.address}
              onChange={(e)=>locationValueChange(e.target.value)}
              id={"Location_Search2"}
              onKeyDown={ handleKeyDown }
            />
          </InputGroup>
          <LocationMapList ShowList={ShowList} locationList={locationList} ResetState={ResetState} OnSelectLocationHandler={OnSelectLocationHandler} cursor={cursor} />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
    currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps,{currentLocationInfo,maintainAirportlist})(PlacesAutocompletePage);

/* <PlacesAutocomplete
name="address"
value={driverinfo.address}
onChange={locationValueChange}
onSelect={getSelectedlocation}
>
{({
  getInputProps,
  suggestions,
  getSuggestionItemProps,
  loading,
}) => (
  <div className="bussinesssetup-location">
    <Form.Group>
      <Form.Control
        type="text"
        {...getInputProps({
          placeholder: t("pages.setupstore.address_place"),
        })}
      />
    </Form.Group>
    <div className="store-location-place">
      {loading ? <div>loading...</div> : null}
      {suggestions.map((suggestion) => {
        const style = {
          backgroundColor: suggestion.active ? "#fff" : "#fff",
          marginLeft: "0px",
          border: "1px solid #d4d4d4",
        };
        return (
          <div
            {...getSuggestionItemProps(suggestion, {
              style,
            })}
          >
            {suggestion.description}
          </div>
        );
      })}
    </div>
  </div>
)}
</PlacesAutocomplete> */